var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSbp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "25.7392mm",
    height: "31.75mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 216.15 266.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path66",
    className: "fil0",
    fill: "#43B02A",
    points: "-0,58.04 32.29,115.75 32.29,150.95 0.04,208.55 "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path68",
    className: "fil0",
    fill: "#43B02A",
    points: "123.98,94.75 154.23,76.2 216.15,76.15 123.98,132.61 "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path70",
    className: "fil0",
    fill: "#43B02A",
    points: "123.8,57.7 123.98,134.11 91.61,114.22 91.61,0 123.81,57.7 "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path72",
    className: "fil0",
    fill: "#43B02A",
    points: "216.15,76.15 154.23,76.2 123.8,57.7 91.61,0 216.15,76.15 "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path74",
    className: "fil0",
    fill: "#43B02A",
    points: "123.98,208.87 123.98,171.8 91.61,152.29 91.63,266.63 "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path76",
    className: "fil0",
    fill: "#43B02A",
    points: "154.16,190.5 32.29,115.75 -0,58.04 216.02,190.42 154.15,190.5 "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path78",
    className: "fil0",
    fill: "#43B02A",
    points: "91.63,266.63 123.97,208.87 154.15,190.5 216.02,190.42 "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path80",
    className: "fil0",
    fill: "#43B02A",
    points: "0.04,208.55 91.88,152.3 61,133.35 32.29,150.95 "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSbp);
export default __webpack_public_path__ + "static/media/sbp.700f410811df852a8a61c054da5846e3.svg";
export { ForwardRef as ReactComponent };